export const FIRST_LOGIN_VIDEO_VERIFICATION_SOURCE_KEY = 'fieldview:first-login-video:from-verification';

export const FIRST_LOGIN_VIDEO_FEATURE_FLAG = 'web.field-view.onboarding-2-0.first-time-login-video';

export const AUTH_VERIFICATION_PATH = '/auth/verification';
